module.exports = __webpack_public_path__ + "static/lsvt-loud-cert-50270db4316efb7d93e8af76954404f3.jpg";